import React, { useEffect, useState } from 'react';
import CardForm from '../../form/CardForm';
import { searchOffers } from '../../../helpers/searchOffers';
import { useHouseOfferSearchParams } from '../../../pages/house-offer/context/HouseOfferSearchParamsContext';
import { Actions } from '../../../../client/Actions';
import SearchHouseFormConfig from './SearchHouseFormConfig';
import { buildUrl } from '../../../helpers/buildUrl';
import { useLoaderContext } from '../../loader/LoaderContext';

const SearchHouse = ({
                       houseId,
                       setResult,
                       onReset,
                       title,
                       onSearchHouse,
                       reservationId,
                       manualDiscounts,
                       manualAdditionalPayments,
                       show = true,
                       paymentModel,
                       width = 4,
                       paymentOnBookingPercentage,
                       securityDepositAmount
                     }) => {
  const { loader, setLoader } = useLoaderContext();
  const { searchParams, setSearchParams } = useHouseOfferSearchParams();

  const [unavailableDates, setUnavailableDates] = useState();
  const [unavailableStartDates, setUnavailableStartDates] = useState();
  const [unavailableEndDates, setUnavailableEndDates] = useState();

  function onSearch(params, onSaved) {
    searchOffers({
      params,
      setLoader,
      setSearchParams,
      setResult,
      reservationId,
      houseId: houseId,
      postLoad: onSearchHouse,
      manualDiscounts,
      manualAdditionalPayments,
      payment: {
        paymentModel: paymentModel,
        paymentOnBookingPercentage: paymentOnBookingPercentage,
        securityDepositAmount: securityDepositAmount
      }
    });

    if (onSaved) {
      onSaved();
    }
  }

  useEffect(() => {
    if (searchParams?.startDate) {
      onSearch(searchParams, onSearchHouse);
    }
  }, [
    searchParams,
    manualDiscounts,
    manualAdditionalPayments,
    paymentModel,
    paymentOnBookingPercentage,
    securityDepositAmount
  ]);

  useEffect(() => {
    if (houseId) {
      const url = buildUrl(`house-availability/${houseId}/unavailable`, {
        reservationId
      });

      Actions.get(url, setUnavailableDates);
    }
  }, [houseId]);

  useEffect(() => {
    if (houseId) {
      const url = buildUrl(`house-availability/${houseId}/unavailable-start`, {
        reservationId
      });

      Actions.get(url, setUnavailableStartDates);
    }
  }, [houseId]);

  useEffect(() => {
    if (houseId) {
      const url = buildUrl(`house-availability/${houseId}/unavailable-end`, {
        reservationId
      });

      Actions.get(url, setUnavailableEndDates);
    }
  }, [houseId]);

  if (!searchParams || (houseId && !unavailableDates) || !show) {
    return <></>;
  }

  return (
    <CardForm
      key={houseId}
      title={title}
      withoutHeader={!title}
      fields={SearchHouseFormConfig(
        unavailableDates,
        unavailableStartDates,
        unavailableEndDates
      )}
      shadow={false}
      width={width}
      disableLoader={true}
      initialData={searchParams}
      saveButton={'Sprawdż dostępność'}
      customSave={setSearchParams}
      customCancel={onReset}
      postSaved={onSearchHouse}
    />
  );
};

export default SearchHouse;
